export default __webpack_public_path__ + "static/media/backmansson.b21ca4a0.webp";